import { useCallback } from 'react';

import { useHistory } from 'react-router-dom';

import * as InsuranceConstants from 'store/insurance/constants';

export const useErrorPagePresenter = ({ error }) => {
  const { type: errorType } = error;

  const history = useHistory();

  const title =
    errorType === InsuranceConstants.ERROR_TYPES.FRONTEND
      ? 'Не удалось загрузить данные'
      : 'Сервис не отвечает';
  const description =
    errorType === InsuranceConstants.ERROR_TYPES.FRONTEND
      ? 'Попробуйте обновить'
      : 'Попробуйте обновить или напишите в чат техподдержки';

  const onRefreshButtonClick = useCallback(() => {
    history.go(0);
  }, []);

  return { description, onRefreshButtonClick, title };
};
